import { render, staticRenderFns } from "./XeroBills.vue?vue&type=template&id=1518d5a8&"
import script from "./XeroBills.vue?vue&type=script&lang=js&"
export * from "./XeroBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports